export default [
    {
        header: 'TRUST'
    },
    {
        title: 'Transparency',
        icon: 'TransparencyIcon',
        children: [
            {
                title: 'Financial',
                route: 'trust-transparency-financial',
                icon: 'TrendingUpIcon',
            },
            {
                title: 'Operational',
                route: 'trust-transparency-operational',
                icon: 'PackageIcon',
            },
            {
                title: 'Technical',
                route: 'trust-transparency-technical',
                icon: 'ClipboardIcon',
            },
        ]
    },
]
